import { Component } from '@angular/core';

@Component({
  selector: 'app-time-tracking',
  templateUrl: './time-tracking.component.html',
  standalone: false,
})
export class TimeTrackingComponent {}
